import store from '../../store'
import {archiveHighlight} from '../../actions/highlights'

export function deleteHighlight(highlightId) {
	store.dispatch(archiveHighlight(highlightId))
}
